<template>
  <div>
    <!-- Page Title Area -->
    <div class="page-title-area">
      <div class="container">
        <h2>{{ title }}</h2>
      </div>
    </div>

    <!-- Announcement Content Area -->
    <section class="ptb-80">
      <div class="container">
        <div v-if="loading" class="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div v-else-if="error" class="alert alert-danger" role="alert">
          {{ error }}
        </div>
        <div v-else class="announcement-content">
          <div class="announcement-meta mb-4">
            <div v-if="announcement.Date" class="date">
              <i data-feather="calendar"></i> {{ formatDate(announcement.Date) }}
            </div>
            <div v-if="announcement.Category" class="category">
              <i data-feather="tag"></i> {{ announcement.Category }}
            </div>
          </div>
          <div v-html="content"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { fetchCmsContent } from '../utils/api'
import feather from 'feather-icons'

export default {
  name: 'AnnouncementView',
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const route = useRoute()
    const title = ref('')
    const content = ref('')
    const announcement = ref(null)
    const loading = ref(true)
    const error = ref(null)

    const formatDate = (dateString) => {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString('en-US', {
        year: 'numeric', 
        month: 'long', 
        day: 'numeric'
      })
    }

    const fetchAnnouncement = async (slug) => {
      loading.value = true
      error.value = null
      
      try {
        const response = await fetchCmsContent('announcement', slug)
        if (response && response.Title) {
          title.value = response.Title
          content.value = response.Html || response.Content || ''
          announcement.value = response
          document.title = `${response.Title} - AtOnline.com`
        } else {
          error.value = 'Announcement not found'
        }
      } catch (err) {
        console.error('Error fetching announcement:', err)
        error.value = 'Error loading announcement content'
      } finally {
        loading.value = false
        setTimeout(() => {
          feather.replace()
        }, 100)
      }
    }

    onMounted(() => {
      fetchAnnouncement(props.slug)
    })

    // Watch for route changes
    watch(() => route.params.slug, (newSlug) => {
      if (newSlug && newSlug !== props.slug) {
        fetchAnnouncement(newSlug)
      }
    })

    return {
      title,
      content,
      announcement,
      loading,
      error,
      formatDate
    }
  }
}
</script>

<style scoped>
.announcement-content {
  min-height: 300px;
}

.announcement-meta {
  display: flex;
  gap: 20px;
  color: #6084a4;
}

.announcement-meta .date, 
.announcement-meta .category {
  display: flex;
  align-items: center;
  gap: 5px;
}

.announcement-meta svg {
  width: 16px;
  height: 16px;
}
</style>